<router-outlet />

@if (!network.isOnline()) {
  <ntt-offline />
}

@if (_pwaUi.showUpdate()) {
  <ntt-update-prompt />
}

@if (_pwaUi.showInstall()) {
  <div class="pwa-banners">
    <ntt-install-banner />
  </div>
}

@if (environment.devTools) {
  @if (isResponsivePopup) {
    <div class="dev-viewport-badge" aria-live="polite">
      {{ viewportWidth() }} × {{ viewportHeight() }}
    </div>
  } @else {
    <div class="dev-tools">
      <button
        nttIconButton
        theme="error-ghost"
        size="sm"
        (click)="toggleTheme()"
      >
        <span
          [class]="themeService.isDark() ? 'icon-sun' : 'icon-moon-01'"
        ></span>
      </button>
      <button nttIconButton theme="solid" size="sm" (click)="toggleDirection()">
        <span
          [class]="
            direction() === 'rtl' ? 'icon-align-right-01' : 'icon-align-left-01'
          "
        ></span>
      </button>
      <a nttIconButton theme="solid" size="sm" routerLink="/">
        <span class="icon-home-03"></span>
      </a>
      <a nttIconButton theme="solid" size="sm" routerLink="/storybook">
        <span class="icon-figma"></span>
      </a>
      <button
        nttIconButton
        theme="solid"
        size="sm"
        type="button"
        title="پنجره ریسپانسیو"
        aria-label="باز کردن پنجره ریسپانسیو"
        (click)="openResponsiveWindow()"
      >
        <span class="icon-phone-01"></span>
      </button>
    </div>
  }
}
